import type { AssetNameValidationResult } from "app/services/user-asset-name/userAssetNameUtils";
import { userAssetNameUtils } from "app/services/user-asset-name/userAssetNameUtils";
import { SwRedux } from "app/services/SwRedux";
import { EMPTY_CUSTOM_SEGMENTS, EMPTY_SEGMENT_MODULE } from "app/services/segments/segmentsApiService";

const SEGMENT_NAME_MAX_LENGTH = 100;
const INFINITE_LOOP_THRESHOLD = 500;

export const validateSegmentName = (name: string): AssetNameValidationResult => {
    const { errorBuilder, isEmptyName, isLongerThanMaxLength, hasInvalidCharacters } = userAssetNameUtils;
    const error = errorBuilder();
    if (isEmptyName(name)) {
        return error("segments.wizard.error.emptyname");
    }
    if (isLongerThanMaxLength(name, SEGMENT_NAME_MAX_LENGTH)) {
        return error("segments.wizard.error.name.too.long");
    }
    if (hasInvalidCharacters(name)) {
        return error("segments.wizard.error.special.characters");
    }

    if (isExistingName(name)) {
        return error("segments.wizard.error.existing.name");
    }
    return { isValid: true };
};

const isExistingName = (name) => {
    const swRedux = SwRedux.getInstance();
    const { segmentsModule = EMPTY_SEGMENT_MODULE } = swRedux.getState();
    const { customSegmentsMeta = EMPTY_CUSTOM_SEGMENTS } = segmentsModule;
    const { Segments } = customSegmentsMeta;
    return Segments.some(({ segmentName }) => segmentName === name);
};
export const generateUniqueName = (name: string) => {
    let uniqueName = name;
    let counter = 1;
    while (isExistingName(uniqueName) && counter < INFINITE_LOOP_THRESHOLD) {
        uniqueName = `${name} (${counter})`;
        counter++;
    }
    return uniqueName;
};
